import type { CreditState } from "api";
import { formatCount } from "utils/number.utils";
import type { BillingView } from "./credits.model";
import { balanceLine } from "./credits.model";
import { QCreditLogo } from "./QCreditLogo";

type BalanceCardProps = {
  state: CreditState;
  view: BillingView;
};

/**
 * "QCredits balance". Empty, it is the free monthly credits; filled, the whole
 * balance with the last top-up or the auto top-up under it.
 */
export const BalanceCard = ({ state, view }: BalanceCardProps) => {
  const shown = view.empty ? state.balance.free : state.balance.total;

  return (
    <div className="pcx">
      <div className="pcx__top">
        <div>
          <div className="pcx__h">QCredits balance</div>
          <p className="pcx__sub">{balanceLine(state, view)}</p>
        </div>
        <div className="acr__val" role="img" aria-label={`${formatCount(shown)} QCredits`}>
          <b>{formatCount(shown)}</b>
          <QCreditLogo />
        </div>
      </div>
    </div>
  );
};
